import { HttpErrorResponse } from "@angular/common/http";
import { Observable, catchError, map, of } from "rxjs";
import { ApiModel } from "src/app/infrastructure/lobby-proxy/DTOs/base-DTOs/api-model.dto";

export function catchSoftNotFoundError<T extends ApiModel>(httpCall$: Observable<T>): Observable<T | null> {
    return httpCall$.pipe(
        catchError((e: HttpErrorResponse) => {
            if (e.status == 404) return of(null)
            else throw e
        })
    )

}